<template>
  <div v-if="loaded">
    <div class="spareparts_basket px-4 py-5" :class="[theme == 'dark' ? 'bg-third-dark' : 'bg-fifth-white','spareparts_basket--'+theme, 'text-primary-'+theme]">
      <h2 class="pb-5">{{ t('general.basket') }} ({{ articlesLoaded.length }} {{t('checkout.article')}})</h2>
      <div class="spareparts_basket__articles">
        <div v-for="(article) in articlesLoaded" class="row mx-0 spareparts_basket__articles__item pt-3 pb-5">
          <div class="col-auto col-lg-4 px-0 px-sm-3 px-lg-0 py-xl-1 spareparts_basket__articles__item__img">
            <template v-if="article.productData.color.fabricId != null && article.productData.color.fabricId != '' && article.productData.medias[0].path != '//suncomfort.glatz.com/media/glatz_thumbnail.png'">
              <div class="spareparts_basket__articles__item__img--fabric" :class="'bg-specialbackground-'+theme" v-if="article.productData.medias[0].path" :style="{ backgroundImage: 'url(' + article.productData.medias[0].path + ')' }"></div>
            </template>
            <template v-else>
              <div class="" :class="'bg-specialbackground-'+theme" v-if="article.productData.medias[0].path" :style="{ backgroundImage: 'url(' + article.productData.medias[0].path + ')' }"></div>
            </template>
          </div>
          <div class="pl-3 pr-0 pr-sm-3 pr-lg-0 spareparts_basket__articles__item__details">
            <div class="d-flex justify-content-between">
              <h3 class="pr-2">{{ article.productData.title }}</h3>
              <h4 class="">{{ article.productData.priceFormatted }}</h4>
            </div>
            <p class="pt-3">{{ t('general.count') }} {{ article.productQty }}</p>
            <p class="spareparts_basket__articles__item__details__delete" @click="removeProduct(article.id,article.productQty)">{{t('checkout.remove')}}</p>
          </div>
        </div>
      </div>
      <div class="d-flex pt-5 justify-content-between">
        <p>{{ t('general.deliverycost') }}</p>
        <p>{{ deliverPrice }}</p>
      </div>
      <div class="d-flex pt-1 pb-2 justify-content-between">
        <p>{{ t('general.wholeprice') }}</p>
        <p>{{ wholePrice }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {FireI18n} from 'fire-js-i18n';
import {eventBus} from 'fire-vue-core';
import gql from "fake-tag";
export default {
  name: 'basket',
  data: () => ({
    loaded: false,
    svgcolor1: '',
    articlesLoaded: [],
    wholePrice: 0,
    basketId: 0,
    deliverPrice: 0,
  }),
  computed: {},
  components: {},
  directives: {},
  mixins: [],
  props: {
    articles: Array,
    theme: String,
    currencydisplay: String,
  },
  watch: {},
  created()
  {

  },
  destroyed()
  {

  },
  mounted()
  {
    this.setColors(this.theme);
    this.getBasket();
  },
  methods: {
    t(key, options)
    {
      return FireI18n.t(key, options);
    },
    setColors(theme)
    {
      if(theme == 'dark')
      {
        this.svgcolor1 = '#fff';
      }
      else if(theme == 'white')
      {
        this.svgcolor1 = '#000';
      }
    },
    getBasket()
    {
      const body = {
        query: gql`query {
                              basket {
                                id
                                errors
                                positions {
                                  id
                                  productCount
                                  productQty
                                  productData {
                                    shopProductId
                                    medias(targetAttr: "image") {
                                      path
                                    }
                                    title
                                    sku
                                    inStock
                                    price
                                    priceFormatted
                                     color {
                                        fabricId:code
                                    }
                                  }
                                }
                                summary
                                {
                                  positionCount
                                  productCount
                                  productQty
                                  currency
                                  subTotal(formatted: false)
                                }
                              }
                            }`,
      };


      fetch(graphqlApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': yii.getCsrfToken()
        },
        body: JSON.stringify(body)
      })
          .then(res => res.json())
          .then(res =>
          {
            console.dir(res);
            if(!res.error)
            {
              this.articlesLoaded = res.data.basket.positions;
              this.wholePrice= res.data.basket.summary.subTotal;
              this.basketId = res.data.basket.id;
              eventBus.$emit('BasketIdLoaded', this.basketId);
              this.calculateShippingCosts(this.basketId);

            }
          });
    },
    calculateShippingCosts(id)
    {
      const body = {
        "basketId": id
      }
      fetch(apiBaseUrl+'shop/shippingcost', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': yii.getCsrfToken()
        },
        body: JSON.stringify(body)
      })
          .then(res => res.json())
          .then(res =>
          {
            this.deliverPrice = this.formatPrice(res.shipping_costs_normal);
            let wholePrice = Number(this.wholePrice) + Number(res.shipping_costs_normal);
            this.wholePrice =  this.formatPrice(wholePrice);
            this.loaded = true;
          })

    },
    removeProduct(id, qty)
    {
      let basketPositionId = id;
      const body = {
        query: gql`mutation removeBasketPosition($basketPositionId : Int) {
                              removeBasketPosition (basketPositionId: $basketPositionId) {
                                   errors
                                     positions {
                                        id
                                        shopBasketId
                                        errors
                                        }
                                }
                            }`,
        variables: { basketPositionId }
      };

      fetch(graphqlApi, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': yii.getCsrfToken()
        },
        body: JSON.stringify(body)
      })
          .then(res => res.json())
          .then(res =>
          {
            console.dir(res)
            if(!res.error)
            {
              this.getBasket();
              eventBus.$emit('CallGetBasketProducts');
            }
          });
    },
    formatPrice(price) {
      return price.toFixed(2) + this.currencydisplay;
    }
  }
};
</script>

<style lang="scss">
@import "frontend/styles/framework";

.spareparts_basket {
  h2 {
    font-size: 1.3rem;
  }

  p {
    font-size: 1rem;
  }

  &--dark {
    p {
      font-weight: 700;
    }

    h2 {
      font-weight: 400;
    }

    .spareparts_basket {
      &__articles {
        &__item {
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);

          &__details {
            flex: 1;
            &__delete{
              color: $secondary_dark;
              &:hover{
                color: $secondary_dark;
              }
            }
            h3 {
              font-weight: 600;
            }

            h4 {
              font-weight: 400;
              text-align: right;
              white-space: nowrap;
            }

            p {
              font-weight: 200;
            }
          }
        }
      }
    }
  }

  &--white {
    h2 {
      font-weight: 500;
    }

    p {
      font-weight: 800;
    }

    .spareparts_basket {
      &__articles {
        &__item {
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);

          &__details {
            &__delete{
              &:hover{
                color: $secondary_white;
              }
            }
            h3 {
              font-weight: 800;
            }

            h4 {
              font-weight: 600;
            }

            p {
              font-weight: 300;
            }
          }
        }
      }
    }
  }

  &__articles {
    &__item {
      &__img {
        &--fabric{
          background-size: cover !important;
        }
        > div {
          width: 80px;
          padding-bottom: 100%;
          background-position-y: center;
          background-position-x: center;
          background-size: 70%;
          background-repeat: no-repeat;
        }
      }

      &__details {
        &__delete{
          transition: color 0.3s;
          cursor: pointer;
        }
        h3 {
          font-size: 0.875rem;
          word-break: break-word;
        }

        h4 {
          font-size: 0.9rem;
        }

        p {
          font-size: 0.85rem;
        }
      }
    }
  }

  @media (min-width: 375px) {
    .spareparts_basket {
      &__articles {
        &__item {
          &__details {
            h3 {
              font-size: 0.95rem;
            }
          }
        }
      }
    }
  }

  @media (min-width: 576px) {
    .spareparts_basket {
      &__articles {
        &__item {
          &__details {
            h3 {
              font-size: 1rem;
            }
          }
        }
      }
    }
  }
  @media (min-width: 768px) {
    .spareparts_basket {
      &__articles {
        &__item {

          &__details {
            h3 {
              font-size: 1.1rem;
            }
          }
        }
      }
    }
  }
  @media (min-width: 992px) {
    .spareparts_basket {
      &__articles {
        &__item {
          &__img{
            > div{
              width: auto;
            }
          }
          &__details {
            h3 {
              font-size: 0.9rem;
            }
          }
        }
      }
    }
  }
  @media (min-width: 1200px) {
    .spareparts_basket {
      &__articles {
        &__item {
          &__details {
            h3 {
              font-size: 1rem;
            }
          }
        }
      }
    }
  }
}

</style>